export interface PurchaseOrderSupplier {
  supplierId: string;
  supplierKey: string;
  supplierName: string;
  supplierAddressMultiLine: string;
  productionProcessId: string;
  deliveryAddressId: string;
  deliveryAddressMultiLine: string;
  invoiceAddressId: string;
  invoiceAddressMultiLine: string;
  paymentTermId: string;
  paymentDueDate: Date;
  currencyId: string;
  settlementTermId: string;
  sellingCompanyId: string;
  serviceRepId: string;
  taxId: string;
  vATRegNo: string;
  bankId: string;
  portId: string;
  modeOfTransportId: string;
  deliveryTermId: string;
  deliveryAddresseeId: string;
  deliveryAddressee: string;
  invoiceAddresseeId: string;
  invoiceAddressee: string;
}
